import { BoostProvider, BoostTask } from '../types/boost';
import { AdextraBoostProvider } from './AdextraBoostProvider';
import { OnClickABoostProvider } from './OnClickABoostProvider';
import { MonetagBoostProvider } from './MonetagBoostProvider';

const PROVIDERS = {
  ADEXTRA: 'adextra',
  ONCLICK: 'onclick',
  MONETAG: 'monetag',
};

export class RandomizedAdProvider implements BoostProvider {
  private currentProvider: BoostProvider | null = null;
  private currentType: 'adextra' | 'onclick' | 'monetag' | null = null;

  private createProvider(): void {
    // Очищаем предыдущий провайдер
    this.resetProvider();

    // Сначала пробуем Monetag
    this.currentType = 'monetag';
    this.currentProvider = new MonetagBoostProvider();

    console.log(
      `RandomizedAdProvider: Инициализирован провайдер ${this.currentType}`,
    );
  }

  private createRandomProvider(): void {
    // Очищаем предыдущий провайдер
    this.resetProvider();

    // Выбираем случайно между OnClick и Adextra
    const types: Array<'adextra' | 'onclick'> = ['adextra', 'onclick'];
    const randomIndex = Math.floor(Math.random() * types.length);
    this.currentType = types[randomIndex];

    switch (this.currentType) {
      case 'adextra':
        this.currentProvider = new AdextraBoostProvider();
        break;
      case 'onclick':
        this.currentProvider = new OnClickABoostProvider();
        break;
    }
    console.log(
      `RandomizedAdProvider: Инициализирован случайный провайдер ${this.currentType}`,
    );
  }

  private resetProvider(): void {
    if (this.currentProvider) {
      // Сбрасываем ошибки текущего провайдера перед его удалением
      this.resetError();
    }
    this.currentProvider = null;
    this.currentType = null;
    console.log('RandomizedAdProvider: Сброшено состояние провайдера');
  }

  getName(): string {
    if (!this.currentType) {
      this.createProvider();
    }
    switch (this.currentType) {
      case 'monetag':
        return PROVIDERS.MONETAG;
      case 'adextra':
        return PROVIDERS.ADEXTRA;
      case 'onclick':
        return PROVIDERS.ONCLICK;
      default:
        return '';
    }
  }

  async getAvailableTasks(miningId: number): Promise<BoostTask[]> {
    // Сначала пробуем Monetag
    this.createProvider();

    if (!this.currentProvider) {
      return [];
    }

    try {
      const tasks = await this.currentProvider.getAvailableTasks(miningId);

      // Если есть задания от Monetag, возвращаем их
      if (tasks.length > 0) {
        return tasks.map((task) => ({
          ...task,
          provider: this.getName(),
          onClick: async () => {
            try {
              const result = await task.onClick();
              // После выполнения задачи сбрасываем провайдер
              this.resetProvider();
              return result;
            } catch (error) {
              this.resetProvider();
              throw error;
            }
          },
        }));
      }

      // Если заданий от Monetag нет, пробуем случайный провайдер
      this.createRandomProvider();

      if (!this.currentProvider) {
        return [];
      }

      const randomTasks =
        await this.currentProvider.getAvailableTasks(miningId);
      return randomTasks.map((task) => ({
        ...task,
        provider: this.getName(),
        onClick: async () => {
          try {
            const result = await task.onClick();
            // После выполнения задачи сбрасываем провайдер
            this.resetProvider();
            return result;
          } catch (error) {
            this.resetProvider();
            throw error;
          }
        },
      }));
    } catch (error) {
      this.resetProvider();
      return [];
    }
  }

  resetError(): void {
    if (this.currentProvider) {
      const provider = this.currentProvider as unknown as {
        resetError?: () => void;
      };
      if (typeof provider.resetError === 'function') {
        provider.resetError();
      }
    }
  }
}
